import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';
import { CommonStyles } from '../../themes/themes';

export interface IPageHeaderStyles {
  root: IStyle;
  header?: IStyle;
  titleContainer?: IStyle;
  title?: IStyle;
  titleContents?: IStyle;
  description?: IStyle;
  breadcrumb?: IStyle;
  actions?: IStyle;
  contents?: IStyle;
  secondaryHeader?: IStyle;
  secondaryContents?: IStyle;
  secondaryActions?: IStyle;
}

export interface IPageHeaderClassNames {
  root: string;
  header: string;
  titleContainer: string;
  title: string;
  titleContents: string;
  description: string;
  breadcrumb: string;
  actions: string;
  secondaryContents: string;
  contents: string;
  secondaryHeader: string;
  secondaryActions: string;
}

export const pageHeaderStylesDefault = (theme: IH2OTheme): Partial<IPageHeaderStyles> => ({
  root: {},
  header: {},
  titleContainer: { flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 24 },
  title: {
    fontSize: FontSizes.xlarge,
    fontWeight: FontWeights.semiBold,
  },
  titleContents: { flex: 1 },
  actions: { marginLeft: Sizes.padding },
  description: {
    marginTop: '4px',
    color: theme.semanticColors?.textSecondary,
  },
  breadcrumb: { marginTop: '4px' },
  secondaryHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '16px',
  },
  secondaryContents: {
    flex: 1,
  },
  secondaryActions: { marginLeft: Sizes.padding, ...CommonStyles.flexCenterVertically },
});

export const pageHeaderStylesSecondary: Partial<IPageHeaderStyles> = {
  title: {
    fontSize: FontSizes.large,
    fontWeight: FontWeights.normal,
  },
};
